const DEFAULT_TRADEMARK_NOTICE =
  "QR Code is a registered trademark of DENSO WAVE INCORPORATED.";

const TRADEMARK_NOTICE_BY_LANGUAGE = {
  ja: "QRコードは株式会社デンソーウェーブの登録商標です。",
  th: "QR Code เป็นเครื่องหมายการค้าจดทะเบียนของ DENSO WAVE INCORPORATED",
  zh: "QR Code 是 DENSO WAVE INCORPORATED 的註冊商標。",
  ko: "QR Code는 DENSO WAVE INCORPORATED의 등록상표입니다.",
  id: "QR Code adalah merek terdaftar DENSO WAVE INCORPORATED.",
  ms: "QR Code ialah tanda dagangan berdaftar DENSO WAVE INCORPORATED.",
  fr: "QR Code est une marque déposée de DENSO WAVE INCORPORATED."
};

const normalizeLanguage = (language) =>
  String(language || "en").trim().toLowerCase().split("-")[0];

export const getTrademarkNotice = (language, localizedNotice) =>
  String(localizedNotice || "").trim() ||
  TRADEMARK_NOTICE_BY_LANGUAGE[normalizeLanguage(language)] ||
  DEFAULT_TRADEMARK_NOTICE;

const featureSignature = (items) =>
  JSON.stringify(
    (Array.isArray(items) ? items : []).map((item) => ({
      title: String(item?.title || "").trim(),
      description: String(item?.description || "").trim()
    }))
  );

export const shouldRenderProductFeatures = ({ page, commonFeatures, route }) => {
  if (!Array.isArray(page?.features) || page.features.length === 0) return false;
  if (route?.group === "social" || route?.group === "payment") return false;
  return featureSignature(page.features) !== featureSignature(commonFeatures);
};

export const applyTemplateCommitmentLabels = (items, common) =>
  (Array.isArray(items) ? items : []).map((item, index) =>
    index === 1 && common?.noWatermark
      ? { ...item, title: common.noWatermark }
      : item
  );
